var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSuccessChecked = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5013 16.8327C3.89893 16.8327 0.167969 13.1017 0.167969 8.49935C0.167969 3.89697 3.89893 0.166016 8.5013 0.166016C13.1036 0.166016 16.8346 3.89697 16.8346 8.49935C16.8346 13.1017 13.1036 16.8327 8.5013 16.8327ZM7.67014 11.8327L13.5627 5.94012L12.3842 4.76162L7.67014 9.47568L5.31314 7.1186L4.13463 8.29718L7.67014 11.8327Z",
    fill: "#3BB700"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSuccessChecked, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/success-checked.2fce2e3a.svg";
export { ForwardRef as ReactComponent };